export const Gender = {
   MALE: 'male',
   FEMALE: 'female',
   OTHERS: 'others',
   RATHER_NOT_SAY: 'rather_not_say',
} as const;

export type TGender = (typeof Gender)[keyof typeof Gender];
